// extracted by css-extract-rspack-plugin
export default {"root":"eq6mSLBc90AXMrte"};